module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/lines/wall/wall.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/lines/wall/wall.png
// module id = 464
// module chunks = 0